var _path, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 346,
    viewBox: "0 0 542 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.519 382.494C428.719 398.471 373.72 370.511 338.188 317.703C326.374 352.666 303.414 379.356 271.435 390.275C227.004 405.422 176.196 386.359 136.715 345.222C126.724 383.946 105.769 412.451 75.2474 422.852C20.6428 441.475 -47.8711 396.63 -94.6707 318.196C-105.118 331.579 -118.511 341.643 -134.546 347.116C-193.494 367.217 -265.378 317.755 -295.141 236.649C-324.903 155.543 -301.245 73.4778 -242.328 53.3505C-208.769 41.9122 -171.02 53.0133 -139.253 79.6768C-129.049 42.0678 -108.307 14.4447 -78.3623 4.19949C-24.9117 -14.0344 41.8711 28.5545 88.5493 103.902C101.487 78.7431 121.348 59.8348 146.98 51.0681C205.077 31.252 274.108 70.0022 314.439 140.059C325.493 115.47 343.684 96.9251 367.737 88.703C426.685 68.6016 498.57 118.064 528.332 199.17C558.094 280.275 534.436 362.341 475.519 382.468V382.494Z",
    fill: "url(#paint0_linear_2697_162)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2697_162",
    x1: 259.318,
    y1: -94.9845,
    x2: 92.8714,
    y2: 405.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182692,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#A3FFFF",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567308,
    stopColor: "#4CFFFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#15FFFF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud_1.b76113064b781ed3bb6eb6ee04985257.svg";
export { ForwardRef as ReactComponent };